/** 해시태그 문자열 → `#태그` 배열 (중복·대소문자 정규화) */
export function parseHashtags(hashtags) {
  if (!hashtags) return [];

  const seen = new Set();
  const result = [];

  String(hashtags)
    .split(/\s+/)
    .map((tag) => tag.trim())
    .filter(Boolean)
    .forEach((tag) => {
      const normalized = tag.startsWith("#") ? tag : `#${tag}`;
      const key = normalized.toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        result.push(normalized);
      }
    });

  return result;
}

/** HTML 문자열에서 태그를 제거해 검색용 평문으로 변환 */
export function stripHtmlToText(html) {
  if (!html) return "";
  return String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
}

export function mapColumnToFaqItem(column) {
  return {
    id: column.id,
    hashtags: parseHashtags(column.hashtags),
    question: column.title,
    title: column.title,
    created_at: column.created_at,
  };
}

export function matchesFaqSearch(item, keyword) {
  const trimmed = (keyword ?? "").trim().toLowerCase();
  if (!trimmed) return true;

  const haystack = [
    item.question ?? "",
    stripHtmlToText(item.content),
    item.hashtags.join(" "),
  ]
    .join(" ")
    .toLowerCase();

  return haystack.includes(trimmed);
}

export function buildFaqHashtagFilters(items) {
  const tagMap = new Map();

  items.forEach((item) => {
    item.hashtags.forEach((tag) => {
      const key = tag.toLowerCase();
      if (!tagMap.has(key)) {
        tagMap.set(key, tag);
      }
    });
  });

  const hashtagFilters = Array.from(tagMap.entries())
    .sort(([a], [b]) => a.localeCompare(b, "ko"))
    .map(([id, label]) => ({ id, label }));

  return [{ id: "all", label: "전체" }, ...hashtagFilters];
}

export function matchesFaqHashtagFilter(item, filterId) {
  if (filterId === "all") return true;
  return item.hashtags.some((tag) => tag.toLowerCase() === filterId);
}

/**
 * 서버 `/columns/hashtags` 응답([{ hashtag, count }, ...])으로 필터 바를 구성한다.
 * id 는 서버에 그대로 `?hashtag=` 로 넘길 원본 태그 문자열,
 * label 은 화면 표시용 `#태그` 정규화 문자열.
 */
export function buildFaqHashtagFiltersFromApi(apiHashtags) {
  const seen = new Set();
  const filters = (apiHashtags ?? [])
    .map((entry) => (entry?.hashtag ?? "").trim())
    .filter(Boolean)
    .filter((raw) => {
      const key = raw.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .map((raw) => ({
      id: raw,
      label: raw.startsWith("#") ? raw : `#${raw}`,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, "ko"));

  return [{ id: "all", label: "전체" }, ...filters];
}

export function enhanceFaqContentLinks(container) {
  if (!container) return;

  const links = container.querySelectorAll("a");
  links.forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");

    const href = link.getAttribute("href");
    if (href && !/^https?:\/\//i.test(href) && !/^mailto:/i.test(href)) {
      link.setAttribute("href", `https://${href}`);
    }
  });
}
